module.exports = __webpack_public_path__ + "fonts/Inter-600-latin45.5eb4a77.woff2";